import { render, staticRenderFns } from "./detail-project.vue?vue&type=template&id=2ca3a4c5"
import script from "./detail-project.vue?vue&type=script&lang=js"
export * from "./detail-project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports